module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("XoJWs"))).then(() => module.bundle.root('iDabs'));